import { Alert, Typography, Grid } from '@mui/material';
import { TextField } from 'components/ui/inputs';
import { Section, Header, Content } from 'components/ui/forms';

const EMPTY_OPTIONS = [];

export default function SeasonFields({
    parentMode,
    parentEventId,
    capacity,
    capacityError,
    seasons = EMPTY_OPTIONS,
    onChange,
    disabled,
    seatingEnabled = false,
    seatingChartKey,
    seatingLayoutName,
    inheritedSeating = false,
    relationshipLocked = false,
    used,
    remaining,
}) {
    if (parentMode) {
        return (
            <Alert severity="info">
                Season tickets admit their holder once to each linked event. Add events from the
                events list. Season copies start without linked events.
                {seatingEnabled
                    ? ' Buyers keep the same seat for every linked event. Set season ticket prices in Tickets.'
                    : ''}
            </Alert>
        );
    }

    if (seasons.length === 0 && !parentEventId) {
        return null;
    }

    const selectedSeason = seasons.find(
        (season) => String(season.event_id) === String(parentEventId),
    );
    const assignedSeason = Number(selectedSeason?.seats_flag) === 1 || inheritedSeating;

    return (
        <Section>
            <Header>Season</Header>
            <Typography>
                Link this event to a season so season ticket holders can attend this event.
            </Typography>
            <Content>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            id="parentEventId"
                            label="Season"
                            select
                            SelectProps={{ native: true }}
                            InputLabelProps={{ shrink: true }}
                            value={parentEventId || ''}
                            disabled={disabled || relationshipLocked}
                            helperText={
                                relationshipLocked
                                    ? 'This event belongs to an assigned-seating season. It cannot be removed or transferred.'
                                    : seatingEnabled
                                    ? 'Choose an assigned-seating season with the same layout. Only events without sales can be linked.'
                                    : undefined
                            }
                            onChange={onChange}
                        >
                            <option value="">No Season</option>
                            {parentEventId && !selectedSeason && (
                                <option value={parentEventId}>Current season (#{parentEventId})</option>
                            )}
                            {seasons.map((season) => (
                                <option
                                    key={season.event_id}
                                    value={season.event_id}
                                    disabled={
                                        seatingEnabled &&
                                        (Number(season.seats_flag) !== 1 ||
                                            season.seat_chart_key !== seatingChartKey)
                                    }
                                >
                                    {season.event_title}
                                </option>
                            ))}
                        </TextField>
                    </Grid>
                    {parentEventId && !assignedSeason ? (
                        <Grid item xs={12}>
                            <TextField
                                id="seasonAdmissionCapacity"
                                label="Admission Capacity"
                                type="number"
                                value={capacity}
                                error={Boolean(capacityError)}
                                helperText={
                                    capacityError ||
                                    'Maximum number of guests that can attend this event. Includes admission ticket holders and season ticket holders. Leave blank for no limit.'
                                }
                                    sx={{
                                    '& input[type=number]': {
                                        MozAppearance: 'textfield',
                                    },
                                    '& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button': {
                                        WebkitAppearance: 'none',
                                        margin: 0,
                                    },
                                }}
                                disabled={disabled}
                                onChange={onChange}
                                />
                        </Grid>
                    ) : null}
                </Grid>
            </Content>
        </Section>
    );
}
